import { useState, useEffect } from "react";
import ImageViwer from "../ImageViwer";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import usePropertyData from "../data-fetch/property-data-fetch";
import useUpdateVehicleData from "../../Fleet-managment/dataFetch/addVehicle";
import FilterComponent from "../../Fleet-managment/Vehicle-management/FilterComponent";

type Cluster = {
  clusterDDN: string;
  isChecked: boolean;
};

type Tsp = {
  DDNNumber: string;
  isChecked: boolean;
};
export default function ViewProperty() {
  const navigate = useNavigate();
  const params = useParams();
  const id: string = (params.id as string) || "";
  const propertyDetails = usePropertyData({ id });
  const { getClusterListWardWise, getTspList, updatePropertyTsp } =
    useUpdateVehicleData();
  const property = propertyDetails?.propertyDetails || {};
  // console.log("✅ Final API to Set data ", property);
  const [lastFetchKey, setLastFetchKey] = useState<string>("");

  const [openImage, setOpenImage] = useState<boolean>(false);
  const [imgUrl, setImgUrl] = useState<string>("");
  const [selectedCluster, setSelectedCluster] = useState<Cluster[]>([]);
  const [selectedTsp, setSelectedTsp] = useState<Tsp[]>([]);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [filterType, setFilterType] = useState<"cluster" | "tsp" | null>(null);

  useEffect(() => {
    const key = `${property.city}-${property.wardNumber}`;
    if (key === lastFetchKey) return; // skip if already fetched
    async function fetchMaps() {
      if (!property.city || !property.wardNumber) return;

      const allClusterList = await getClusterListWardWise(
        property.city,
        property.wardNumber
      );
      const cluster = allClusterList.map((item: any) => ({
        clusterDDN: item.clusterDDN,
        isChecked: Array.isArray(property.clustermapped)
          ? property.clustermapped.some(
              (mapped: any) =>
                mapped.clusterDDN === item.clusterDDN && mapped.isChecked
            )
          : false,
      }));

      console.log("✅ Final Cluster to Set", cluster);
      // console.log("✅ Final TSP to Set", tsp);
      setSelectedCluster(cluster);
    }

    fetchMaps();
    setLastFetchKey(key);
  }, [property.city, property.wardNumber]);

  const handleViewPictureButton = (e: any, imgUrl: any) => {
    e?.preventDefault();
    if (imgUrl) {
      if (imgUrl)
        typeof imgUrl === "string" ? setImgUrl(imgUrl) : setImgUrl(imgUrl[0]);

      setOpenImage(true);
    } else {
      toast("Image is not available.", { type: "error", theme: "colored" });
    }
  };
  const handleBack = (e: any) => {
    e.preventDefault();
    navigate(-1);
  };

  const handleFilter = (type: "cluster" | "tsp") => {
    setOpenFilter(true);
    setFilterType(type);
  };

  const handleUpdateButton = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const elements = form.elements as any;

    const body = {
      location: {
        type: "Point",
        coordinates: [
          parseFloat(elements.longitude.value),
          parseFloat(elements.latitude.value),
        ],
      },
      country: property?.country || "",
      state: property?.state || "",
      wardNumber: property?.wardNumber || "",
      propertyType: property?.propertyType || "",
      propertySubType: property?.propertySubType || "",
      propertyOwnerName: property?.propertyOwnerName || "",
      propertyName: property?.propertyName || "",
      landmark: property?.landmark || "",
      latitude: property?.location?.coordinates[1] || "",
      longitude: property?.location?.coordinates[0] || "",
      city: property?.city || "",
      userCreatedBy: property?.userCreatedBy || "",
      clustermapped: selectedCluster,
    };

    // console.log("FROM SUBMIT OF MAPPED CLUSTER NEW IMP =====>>>",property?._id,"\n",body);

    try {
      const response = await updatePropertyTsp(id, JSON.stringify(body));
      toast(response.message, { type: "success", theme: "colored" });
      navigate(-1);
    } catch (err: any) {
      toast(err.message || "Update failed", {
        type: "error",
        theme: "colored",
      });
    }
  };

  return (
    <>
      <div className="m-20">
        <form className="w-full mt-8" onSubmit={handleUpdateButton}>
          {/* --- DDN and Created By --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                DDN
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 uppercase rounded py-3 px-4 mb-3"
                type="text"
                name="ddn"
                disabled
                defaultValue={property?.DDNNumber}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Created By
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="createdBy"
                disabled
                defaultValue={property?.userCreatedBy}
              />
            </div>
          </div>

          {/* --- Property Type and Owner Name --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Property Type
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="propertyType"
                disabled
                defaultValue={property?.propertyType}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Property Owner Name
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 uppercase rounded py-3 px-4 mb-3"
                type="text"
                name="propertyOwnerName"
                disabled
                defaultValue={property?.propertyOwnerName}
              />
            </div>
          </div>

          {/* --- Latitude and Longitude --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Latitude
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="latitude"
                disabled
                defaultValue={property?.location?.coordinates[1]}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Longitude
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="longitude"
                disabled
                defaultValue={property?.location?.coordinates[0]}
              />
            </div>
          </div>

          {/* --- Landmark and Image --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Property Landmark
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="landmark"
                disabled
                defaultValue={property?.landmark}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Property Image
              </label>
              <button
                className="block w-full bg-recity text-white rounded py-3 px-4 mb-3"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewPictureButton(e, property?.propertyPicture);
                }}
              >
                View Property Image
              </button>
            </div>
          </div>

          {/* --- State and City --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                State
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="state"
                disabled
                defaultValue={property?.state}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                City
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="city"
                disabled
                defaultValue={property?.city}
              />
            </div>
          </div>

          {/* --- Ward and Area --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Ward Number
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="wardNumber"
                disabled
                defaultValue={property?.wardNumber}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                Area
              </label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4 mb-3"
                type="text"
                name="area"
                disabled
                defaultValue={property?.area || "NA"}
              />
            </div>
          </div>

          {/* --- Cluster Section --- */}
          {property?.DDNNumber?.includes("TP") && (
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3">
                <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                  Cluster Mapped
                </label>
                <div className="grid grid-cols-3 gap-2">
                  {selectedCluster?.map((cluster, idx) =>
                    cluster.isChecked ? (
                      <div
                        key={idx}
                        className="bg-lightBlue p-1 rounded text-sm text-white"
                      >
                        {cluster.clusterDDN}
                      </div>
                    ) : null
                  )}
                </div>
              </div>
              <div className="w-full md:w-1/2 px-3">
                <button
                  className="block w-full bg-recity text-white rounded py-3 px-4"
                  onClick={(e) => {
                    e.preventDefault();
                    handleFilter("cluster");
                  }}
                >
                  Manage Clusters
                </button>
              </div>
            </div>
          )}

          {/* --- Submit Buttons --- */}
          <div className="flex justify-center">
            <button
              className="bg-green p-4 m-4 text-white rounded uppercase"
              type="submit"
            >
              Update Property
            </button>
            <button
              className="bg-recity p-4 m-4 text-white rounded uppercase"
              onClick={handleBack}
            >
              Back
            </button>
          </div>
        </form>
      </div>

      {openFilter && filterType === "cluster" && (
        <FilterComponent
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          selectedItems={selectedCluster}
          setSelectedItems={setSelectedCluster}
          labelKey="clusterDDN"
          title="Clusters"
        />
      )}

      {openFilter && filterType === "tsp" && (
        <FilterComponent
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          selectedItems={selectedTsp}
          setSelectedItems={setSelectedTsp}
          labelKey="DDNNumber"
          title="TSPs"
        />
      )}

      {openImage && (
        <ImageViwer setOpenImage={setOpenImage} imageUrl={imgUrl} />
      )}
      <ToastContainer />
    </>
  );
}
